import React, { useEffect, useRef, useState } from 'react';
import Header from '../components/Header';
import ContentRow from '../components/ContentRow';
import Footer from '../components/Footer';
import ContentModal from '../components/ContentModal';
import { setupHoverVideoHandlers } from '../utils/videoHandler';
import { useIsMobile } from '../hooks/use-mobile';

const Filmes = () => {
  const isMobile = useIsMobile();

  const filmesRef = useRef<HTMLDivElement | null>(null);
  const footerRef = useRef<HTMLDivElement | null>(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState<any>(null);

  const openModal = (item: any) => {
    setModalData(item);
    setModalOpen(true);
  };

  const playFullscreen = () => {
    const video = videoRef.current;
    if (video) {
      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if ((video as any).webkitEnterFullscreen) {
        (video as any).webkitEnterFullscreen();
      } else if ((video as any).mozRequestFullScreen) {
        (video as any).mozRequestFullScreen();
      } else if ((video as any).msRequestFullscreen) {
        (video as any).msRequestFullscreen();
      }
      video.play();
    }
  };

  useEffect(() => {
    setupHoverVideoHandlers();
  }, []);

  const destaque = {
    id: '1',
    title: '2 Filhos de Francisco',
    imageSrc: '/img/2_Filhos_de_Francisco.jpg',
    videoSrc: '/videos/2_filho_de_franscico.mp4',
    embedId: '1d7f7abc18fcb43975065399b0d1e48e',
    description: 'Francisco é um lavrador do interior de Goiás que sonha transformar seus dois filhos em uma famosa dupla sertaneja.'
  };

  const filmesPopulares = [destaque, {
    id: '2',
    title: 'O Menino da Porteira',
    imageSrc: '/img/menino_da_porteira.jpg',
    videoSrc: '/videos/menino_da_porteira.mp4',
    embedId: '140f6969d5213fd0ece03148e62e461e'
  }, {
    id: '3',
    title: 'Só Se For por Amor',
    imageSrc: '/img/So_se_for_por_Amor.jpg',
    videoSrc: '/videos/so_se_for_por_amor.mp4',
    embedId: 'bd4c9ab730f5513206b999ec0d90d1fb'
  }];

  const lancamentos = [{
    id: '1',
    title: 'É o amor',
    imageSrc: '/img/e_o_amor.jpg',
    videoSrc: '/videos/e_o_amor.mp4',
    embedId: '3636638817772e42b59d74cff571fbb3'
  }, {
    id: '2',
    title: 'Menino da Porteira',
    imageSrc: '/img/menino_da_porteira.jpg',
    videoSrc: '/videos/menino_da_porteira.mp4',
    embedId: '140f6969d5213fd0ece03148e62e461e'
  }];

  return (
    <div className="bg-[#141414]">
      <Header />

      <main className="pt-[70px] sm:pt-[80px] md:pt-[90px] p-3 sm:p-4 md:p-5 overflow-visible relative">
        <div className="container mx-auto px-0 max-w-full">
          <div className="relative w-full h-[85vh] overflow-hidden rounded-lg shadow-lg mb-10">
            <video
              ref={videoRef}
              className="absolute inset-0 w-full h-full object-cover"
              src={destaque.videoSrc}
              autoPlay
              muted
              loop
              playsInline
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent flex flex-col justify-end p-8">
              <div className="max-w-[600px] bg-black/50 p-6 rounded-lg">
                <h1 className="text-white text-3xl md:text-4xl font-bold">
                  {destaque.title}
                </h1>
                <p className="text-white/90 text-sm md:text-base mt-2">
                  {destaque.description}
                </p>

                {/* Botões padronizados com largura e altura iguais */}
                <div className="flex gap-4 mt-4 w-full max-w-[500px]">
                  <button
                    className="flex items-center justify-center gap-2 px-[20px] h-[48px] rounded font-bold text-rustico-brown bg-white hover:bg-[#bbab95] transition-colors flex-1"
                    onClick={playFullscreen}
                  >
                    <span className="material-symbols-outlined text-[20px]">play_arrow</span>
                    ASSISTIR
                  </button>
                  <button
                    className="flex items-center justify-center gap-2 px-[20px] h-[48px] rounded font-medium text-white bg-[rgba(109,109,110,0.7)] hover:bg-[rgba(109,109,110,0.9)] transition-colors flex-1"
                    onClick={() => openModal(destaque)}
                  >
                    INFORMAÇÕES
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div ref={filmesRef}>
            <ContentRow
              title="Filmes Populares"
              items={filmesPopulares}
              category="filmes-populares"
              fullWidth={true}
            />
            <ContentRow
              title="Lançamentos"
              items={lancamentos}
              category="lancamentos"
              fullWidth={true}
            />
          </div>
        </div>
      </main>

      <div ref={footerRef}>
        <Footer />
      </div>

      {modalOpen && modalData && (
        <ContentModal item={modalData} onClose={() => setModalOpen(false)} />
      )}
    </div>
  );
};

export default Filmes;
